class PlayInViewVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.video = this.querySelector("video");

    if (!this.video) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        console.log(`entry`, entry);
        if (entry.isIntersecting) {
          this.video.play();
          console.log("play");
        } else {
          this.video.pause();
          console.log("pause");
        }
      },
      { rootMargin: "-250px -100px -250px -100px" },
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get("play-in-view-video")) {
  customElements.define("play-in-view-video", PlayInViewVideo);
}
